import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getProjectsByErpOrderNumber = (
    token: string,
    backend: string,
    erpprojectid: any
) => {
    return fetch(
        `${getApiUrl(backend)}projects/by_erpordernumber/${erpprojectid}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
                Accept: 'application/json, text/plain, */*'
            },
        }
    );
};

export default getProjectsByErpOrderNumber;